'use client'

import React, { useEffect } from 'react';
import WizardStep from '@/components/WizardStep';

import { setPageView } from '@habacuscode/habacus_ui_component_library';
import { useRouter } from 'next/navigation';
import { WizardConfig } from '@/types/configuration';


type Props = {
  locale: string;
  tenant: string;
  version: string;
  referralCode?: string;
  schoolCourseTypology?: string;
  step: string[];
  prefillValue: any;
  wizardConfig: WizardConfig;
}

const WizardStepClient = ({
  locale,
  tenant,
  version,
  step,
  referralCode,
  schoolCourseTypology,
  prefillValue,
  wizardConfig,
}: Props) => {
  const router = useRouter();

  console.log('*** WIZ STEP client called ', locale, tenant, version, step, referralCode, schoolCourseTypology)

  useEffect(() => {
    window.scrollTo(0, 0);
    setPageView();
  }, [])

  // Get the current step (default to '1' if not provided)
  const currentStep = step[0];

  console.log('*** currentStep', currentStep)

  // Get the configuration for the current step
  const stepConfig = wizardConfig.steps[currentStep];
  const firstStep = Math.min(...Object.keys(wizardConfig.steps).map(Number));

  if (!stepConfig) {
    router.replace(`/${locale}/${tenant}/${version}/steps/${firstStep}`);
    return;
  }

  let nextStepNumber = Math.max(...Object.keys(wizardConfig.steps).map(Number));
  // Check if we're on the result page
  if (currentStep === 'result') {
    console.log("result")
  } else {
    const stepNumbers = Object.keys(wizardConfig.steps).map(Number).sort((a, b) => a - b);
    const currentStepNumber = Number(currentStep)
    const currentIndex = stepNumbers.indexOf(currentStepNumber);
    if (currentIndex >= 0 && currentIndex < stepNumbers.length - 1) {
      nextStepNumber = stepNumbers[currentIndex + 1];
    }
  }

  return (
    <div className="h-full col-span-12 lg:col-span-8 lg:col-start-3 flex flex-col">
      <div className="w-full">
        <WizardStep
          locale={locale}
          tenant={tenant}
          version={version}
          currentStep={currentStep}
          referralCode={referralCode}
          schoolCourseTypology={schoolCourseTypology}
          totalSteps={Object.keys(wizardConfig.steps).length}
          stepConfig={stepConfig}
          firstStep={firstStep}
          nextStepNumber={nextStepNumber}
          prefillValue={prefillValue}
          wizardConfig={wizardConfig}
        />
      </div>
    </div>
  );
};

export default WizardStepClient;